module.exports = __webpack_public_path__ + "prod/1.42.2/img/header-img-old.9ba1991b.png";